import React from 'react';
import { useNavigate } from 'react-router-dom';

import Img1 from '../../img/products/SistemaContraIncendiosNormalizados/SuccionFinal/SuccionFinal1.png';
import Img2 from '../../img/products/SistemaContraIncendiosNormalizados/SuccionFinal/SuccionFinal2.png';

const SuccionFinal = () => {
  const navigate = useNavigate();

  return (
    <div className="container my-5">
      <h2 className="mb-4 text-center">Sistema Contra Incendios- Succión Final</h2>
      <div className="row align-items-start mb-5">
        {/* Columna izquierda: imágenes en cuadrícula */}
        <div className="col-md-5">
          <div className="row g-2">
            <div className="col-10">
              <img src={Img1} className="img-fluid rounded shadow-sm img-hover-zoom" alt="SuccionFinal 1" />
            </div>
            <div className="col-10">
              <img src={Img2} className="img-fluid rounded shadow-sm img-hover-zoom" alt="SuccionFinal 2" />
            </div>
          </div>
        </div>

        {/* Columna derecha: texto descriptivo */}
        <div className="col-md-7">
          <p className="lead text-justify">
            Las bombas contra incendio de succión final son un tipo de bomba centrífuga diseñada 
            específicamente para suministrar agua a sistemas de extinción de incendios. Estas bombas 
            se caracterizan por tener una configuración compacta en la que la succión y la descarga 
            están alineadas axialmente, lo que facilita su instalación en espacios reducidos y 
            mantenimiento.
          </p>
          <p className="lead text-justify">
            Su diseño compacto y optimizado reduce el consumo energético, mejorando la sostenibilidad 
            del sistema. Gracias a su compatibilidad con motores eléctricos y diésel, estas bombas se 
            pueden implementar en diversas aplicaciones 
          </p>
        </div>
      </div>
    </div>
  );
};

export default SuccionFinal;
